package app.nestbridge.app.usecase

import com.karawek.core.auth.api.Authenticator
import me.tatarka.inject.annotations.Inject

/**
 * Slides the current session forward by re-authenticating it for
 * [durationMinutes] more minutes, so an actively-used session never expires
 * mid-use. No-op (success) when there is no server session to extend.
 */
@Inject
class RenewSessionUseCase(
    private val authenticator: Authenticator,
) {
    suspend operator fun invoke(durationMinutes: Int): Result<Unit> =
        authenticator.renewSession(durationMinutes)
}
